<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link to="/mypage/tickets">お問い合わせ一覧</router-link></li>
                <li class="breadcrumb-item">お問い合わせ</li>
            </ol>
        </nav>
        <div class="container p-0">
            <div class="form-ticket" v-if="is_edit">
                <div class="form-group">
                    <label>種別</label>
                    <select v-model="ticket.ticket_subject_id" class="form-control">
                        <option :value="null">選択してください</option>
                        <option v-for="s in ticket_subjects" :key="s.id" :value="s.id">{{s.subject}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>
                        お問い合わせ内容
                        <div class="small text-muted">
                            お問い合わせにはスクリーンショットを含めることができます。
                        </div>
                    </label>
                    <editor :content="$filters.jsonParse(ticket.topic)"
                        id="ticket-editor"
                        ref="editor"
                        :minHeight="80"
                        @saved="ticketSaved($event)"
                        class=""></editor>
                </div>
                <div class="form-group">
                    <editor-storage
                        :content="ticket.topic"
                        :max="2097152"></editor-storage>
                </div>
                <div class="form-group my-2 text-right">
                    <button type="button" class="btn btn-outline-secondary" @click="is_edit = false" v-if="ticket.id">
                        キャンセル
                    </button>
                    <button type="button" class="btn btn-outline-primary" @click="save()">
                        <i class="fas fa-save"></i>
                        お問い合わせ投稿
                    </button>
                </div>
            </div>
            <div class="form-ticket" v-else-if="ticket.id">
                <div class="card my-4 bg-info" v-if="ticket.closed_at">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <span>
                            <i class="fas fa-check"></i>
                            チケットクローズ
                        </span>
                        <span class="small" data-toggle="tooltip" :title="$filters.dateFormat(ticket.closed_at)">
                            {{$filters.fromNow(ticket.closed_at)}}
                        </span>
                    </div>
                    <div class="card-body">
                        <h3>
                            お問い合わせありがとうございました。
                        </h3>
                        <p>
                            お問い合わせは対応完了、受付済み、保留などの最終処理が行われ、追加の返信が無い場合、
                            一定期間更新がない場合にクローズされます。
                        </p>
                        <div class="small">
                            <p>
                                追加でお問い合わせをご希望の場合は、新たにお問い合わせを追加してください。
                                お問い合わせの作成数に制限はありません。
                                メールやツイッターでもお問い合わせを受け付けています。
                                <br>
                                貸し本棚では、機能に関するご質問、ご要望を受け付けています。
                                また、不具合や障害についてもご連絡頂けると助かります。
                            </p>
                            <p>
                                今後とも貸し本棚を宜しくお願いいたします。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="param ticket-title d-flex justify-content-between align-items-center">
                        <div>
                            チケットID: {{ticket.id}}
                            <h4>{{ticket.ticket_subject.subject}}</h4>
                        </div>
                        <span class="badge badge-secondary badge-pill" v-if="ticket.closed_at">
                            {{$filters.fromNow(ticket.closed_at)}} にクローズ
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <editor :content="$filters.jsonParse(ticket.topic)"
                        :readOnly="true"
                        ref="ticket-viewer"
                        :minHeight="0"
                        class="param"></editor>
                </div>
                <div class="form-group my-2 text-right" v-if="!ticket.closed_at">
                    <button type="button" class="btn btn-outline-secondary" @click="edit()">
                        <i class="fas fa-edit"></i>
                        編集
                    </button>
                </div>
            </div>

            <hr>

            <div class="form-ticket" v-if="ticket.id && !ticket.closed_at">
                <div class="form-group">
                    <label>
                        返信
                    </label>

                    <editor :content="$filters.jsonParse(ticket_topic.topic)"
                        ref="topic_editor"
                        id="topic-editor"
                        :minHeight="100"
                        @saved="topicSaved($event)"
                        class="editor b-light"></editor>
                </div>
                <div class="form-group">
                    <editor-storage
                        :content="ticket_topic.topic"
                        :max="2097152"></editor-storage>
                </div>
                <div class="form-group text-right">
                    <button type="button" class="btn btn-outline-primary btn-sm" @click="saveTopic()">
                        <i class="fas fa-check"></i>
                        返信
                    </button>
                </div>
            </div>

            <div class="form-ticket" v-if="ticket.id">
                <div class="card my-4" v-for="t in ticket.ticket_topics" :key="t.id">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <span>
                            {{t.user.name}}
                            <span class="badge badge-danger badge-pill" v-if="t.user.is_root">管理者</span>
                            <i class="fas fa-history text-primary" v-if="t.is_log"></i>
                        </span>
                        <span class="text-muted small" data-toggle="tooltip" :title="$filters.dateFormat(t.created_at)">
                            {{$filters.dateFormat(t.created_at)}}
                        </span>
                    </div>
                    <div class="card-body">
                        <editor :content="$filters.jsonParse(t.topic)"
                            :id="'editor-' + t.id"
                            :readOnly="true"
                            :minHeight="0"
                            class="article"></editor>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.form-ticket {
    margin: 1rem auto;
}
.param {
    padding: 1rem;
    border: 3px solid #ddd;
    border-radius: .7rem;
}
.ticket-title {
    padding: 1rem 65px;
}
.editor {
    border-radius: .5rem;
    padding: 2rem 0;
}
@media screen and (max-width: 770px) {
    .ticket-title {
        max-width: 100%;
    }
}
</style>

<script>
export default {
    data() {
        return {
            ticket: {
                topic: "",
                ticket_topics: [],
            },
            ticket_subjects: [],
            is_edit: false,
            ticket_topic: {
                topic: "",
                ticket_id: null,
            },
        }
    },
    methods: {
        edit() {
            this.is_edit = true;
        },
        load() {
            if (!isFinite(this.$route.params.id)) {
                this.is_edit = true;
                return;
            }
            axios.get("/mypage/ticket/get", {params: {id: this.$route.params.id}}).then(res => {
                this.ticket = res.data;
                setTimeout(() => {$('[data-toggle="tooltip"]').tooltip();});
            }).catch(err => { alert.err(err.response) });
        },
        init() {
            axios.get("/mypage/ticket/subjects/get").then(res => {
                this.ticket_subjects = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        async save() {
            const saved_data = await this.$refs.editor.save();
            if (saved_data?.blocks?.length == 0) {
                alert.err("内容が空欄です。");
                return;
            }
            this.ticket.topic = JSON.stringify(saved_data);
            axios.post("/mypage/ticket/save", this.ticket).then(res => {
                alert.msg("チケットを保存しました。");
                if (!isFinite(this.$route.params.id)) {
                    this.$router.push(`/mypage/ticket/${res.data}`);
                }
                this.is_edit = false;
                setTimeout(() => {this.load()});
            }).catch(err => { alert.err(err.response) });
        },
        async saveTopic() {
            this.ticket_topic.ticket_id = this.ticket.id;
            const saved_data = await this.$refs.topic_editor.save();
            if (saved_data?.blocks?.length == 0) {
                alert.err("内容が空欄です。");
                return;
            }
            this.ticket_topic.topic = JSON.stringify(saved_data);
            axios.post("/mypage/ticket/topic/save", this.ticket_topic).then(res => {
                alert.msg(res.data);
                this.ticket_topic.topic = "";
                this.$refs.topic_editor.refresh();
                this.load();
            }).catch(err => { alert.err(err.response) });
        },
        topicSaved(ev) {
            this.ticket_topic.topic = JSON.stringify(ev);
        },
        ticketSaved(ev) {
            this.ticket.topic = JSON.stringify(ev);
        },
    },
    computed: {
        placeholder() {
            const s = _.find(this.ticket_subjects, {id: this.ticket.ticket_subject_id});
            if (s) {
                return s.description;
            }
            return "種別を選んでください。";
        },
    },
    mounted() {
        this.load();
        this.init();
    }
}
</script>